// import components
import {
  PaperProps,
  styled,
  Stack,
  StackProps,
  Typography,
  TypographyProps
} from '@mui/material';
import { StyledPaper } from 'components/shared/Paper/StyledPaper.styles';
import { IconButton } from '@sdb/planning-ui';

export const CustomSortableTaskPaper = styled(StyledPaper, {
  shouldForwardProp: (prop) => prop !== 'finishedAllItemTasks'
})<PaperProps & { finishedAllItemTasks?: boolean }>(
  ({ theme, finishedAllItemTasks }) => ({
    position: 'relative',
    backgroundColor: finishedAllItemTasks
      ? '#FCFCF1'
      : theme.palette.common.white,
    '&:hover ': {
      boxShadow: theme.shadows[3],

      '& .tile-remove': {
        opacity: 1,
        visibility: 'visible',
        pointerEvents: 'auto'
      }
    }
  })
);

export const StyledSortableTaskIconButton = styled(IconButton)(({ theme }) => ({
  margin: theme.spacing(-2),
  opacity: 0,
  visibility: 'hidden',
  pointerEvents: 'none',
  transition: 'opacity .2s ease, visibility .2s ease',

  '&:focus-visible': {
    opacity: 1,
    visibility: 'visible',
    pointerEvents: 'auto'
  }
}));

export const StyledSortableTaskIconButtonGrabbingCursor = styled(
  StyledSortableTaskIconButton
)(() => ({
  '&:active': {
    cursor: 'grabbing'
  }
}));

export const StyledSortableTaskStack = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 3),
    margin: theme.spacing(-1, -3),
    borderRadius: theme.spacing(2),
    transition:
      'background-color 0.25s ease, padding 0.25s ease, margin 0.25s ease, border-radius 0.25s ease',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor:
        'rgba(var(--mui-palette-action-activeChannel) / calc(var(--mui-palette-action-hoverOpacity)))'
    }
  })
);

export const StyledCountTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'count'
})<TypographyProps & { count: number }>(({ theme, count }) => ({
  fontSize: '24px',
  lineHeight: 'normal',
  fontFamily: 'SourceSansPro-Bold',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  color:
    count > 3 && count < 5
      ? theme.palette.warning.main
      : count > 5
      ? theme.palette.error.main
      : theme.palette.text.primary
}));

export const StyledCustomMarginIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(-2)
}));
